import React from "react";
import classes from "./Intake.module.scss";
import CustomImage from "../../CustomImage";

const Intake = ({ intakeData }: { intakeData: any }) => {
  const handleIntakeClick = (link: string) => {
    if (!link) return;
    window.open(link, "_blank");
  };

  return (
    <div id="intakes" className={classes["intake-container"]}>
      <h2 className={classes["intake-title"]}>{intakeData?.title ?? ""}</h2>
      <div className={classes["intake-description"]} dangerouslySetInnerHTML={{ __html: intakeData?.description ?? "" }}></div>

      <div className={classes["intake-cards-container"]}>
        {intakeData?.intakeList?.map((el: any) => (
          <div
            className={`${classes["intake-card"]} ${el.link ? classes["intake-card-clickable"] : ""}`}
            key={el.id}
            onClick={() => handleIntakeClick(el.link)}
          >
            <div className={classes["intake-card-bg"]}>
              <CustomImage src={el.imgLink ?? "/images/default-intake-bg.jpg"} alt={el.title} layout="fill" objectFit="cover" />
            </div>

            <div className={classes["intake-card-content"]}>
              <h3 className={classes["intake-card-title"]}>{el.title}</h3>
              <p className={classes["intake-card-description"]}>{el.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Intake;
